"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var InlineIcon_1 = require("./InlineIcon");
var PopupBase_1 = require("./PopupBase");
var Button_1 = require("./Button");
var functional_1 = require("../utils/functional");
var string_1 = require("../utils/string");
var ALERT_DEFAULTS = {
    message: "",
    level: "info",
    type: "message",
    yesButton: "Yes",
    noButton: "No",
    okButton: "Dismiss",
};
var Alert = /** @class */ (function (_super) {
    __extends(Alert, _super);
    function Alert(props) {
        return _super.call(this, props) || this;
    }
    Alert.message = function (params, s) {
        return new Promise(function (resolve) {
            var alertsArea = document.getElementById("AlertsArea");
            if (!alertsArea) {
                throw new Error("Could not find alerts area");
            }
            var optionParams = typeof params === "string" ? { message: params } : params;
            var options = Object.assign({}, ALERT_DEFAULTS, s, optionParams);
            react_dom_1.default.render(react_1.default.createElement(Alert, __assign({ onClose: function (accept) {
                    react_dom_1.default.unmountComponentAtNode(alertsArea);
                    resolve(!!accept);
                } }, options)), alertsArea);
        });
    };
    Alert.error = function (params) {
        return Alert.message(params, { level: "error" });
    };
    Alert.info = function (params) {
        return Alert.message(params, { level: "info" });
    };
    Alert.warning = function (params) {
        return Alert.message(params, { level: "warning" });
    };
    Alert.success = function (params) {
        var okButton = react_1.default.createElement(InlineIcon_1.InlineIcon, { className: "-m-1 w-6 h-6", name: "check" });
        return Alert.message(params, { level: "success", okButton: okButton });
    };
    Alert.question = function (params) {
        return Alert.message(params, { level: "question", type: "yesno" });
    };
    Alert.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(PopupBase_1.PopupBase, { onClose: function () { return _this.props.onClose(false); }, overlay: false },
            react_1.default.createElement("div", { className: "relative overflow-hidden", style: { minWidth: 300, maxWidth: 550 } },
                this.getHeader(this.props.level, this.props.title),
                react_1.default.createElement("div", { className: "w-full flex items-center flex-col pt-4 pb-3" },
                    this.props.htmlContent || (react_1.default.createElement("div", { className: "px-4 py-2 leading-normal text-center" }, this.applyLineBreaks(this.props.message))),
                    react_1.default.createElement("div", { className: "mt-2" }, this.props.type === "message" ? (react_1.default.createElement(Button_1.Button, { onClick: function () { return _this.props.onClose(true); } }, this.props.okButton)) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Button_1.Button, { onClick: function () { return _this.props.onClose(false); } }, this.props.noButton),
                        react_1.default.createElement("span", { className: "px-2" }),
                        react_1.default.createElement(Button_1.Button, { onClick: function () { return _this.props.onClose(true); } }, this.props.yesButton))))))));
    };
    Alert.prototype.applyLineBreaks = function (message) {
        var parts = message.split("\n");
        if (parts.length === 1)
            return message;
        var newLines = (0, functional_1.range)(parts.length - 1).map(function (_, i) { return react_1.default.createElement("br", { key: i }); });
        return react_1.default.createElement(react_1.default.Fragment, null, (0, functional_1.zip)(parts, newLines));
    };
    Alert.prototype.getHeader = function (level, title) {
        var className;
        title = title ? title : (0, string_1.capitalize)(level);
        var Icon;
        switch (level) {
            case "info":
                className = "bg-blue";
                Icon = "warning-circle";
                break;
            case "warning":
                className = "bg-orange";
                Icon = "warning-circle";
                break;
            case "error":
                className = "bg-red";
                Icon = "close-circle";
                break;
            case "success":
                className = "bg-green";
                Icon = "check-circle";
                break;
            case "question":
                className = "bg-orange";
                Icon = "question";
                break;
            default:
                className = "";
                Icon = "question";
        }
        return (react_1.default.createElement("div", { className: "text-xl flex items-center justify-center py-2 text-white ".concat(className) },
            react_1.default.createElement(InlineIcon_1.InlineIcon, { className: "text-xl mr-1", name: Icon }),
            react_1.default.createElement("span", null, title)));
    };
    return Alert;
}(react_1.default.Component));
exports.Alert = Alert;
